<template>
    <div class="login-account">
        <div class="modal fade register-page1" id="staticBackdrop-one" data-bs-backdrop="static" data-bs-keyboard="false"
            tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="container-fluid login-module-wrapper">
                            <div class="row">
                                <button ref="close_btn" @click="refreshData()" type="button" class="btn-close close-top" data-bs-dismiss="modal" aria-label="Close"></button>
                                <div class="col-12 col-md-5">
                                    <div class="text-center">
                                        <img  rel="preload"  class="img-fluid logoregisterPage" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo" alt="logo">
                                        <!-- <img  rel="preload"  src="@/assets/images/betfairlogo.webp" class="img-fluid m-top"> -->
                                        <img  rel="preload"  src="@/assets/images/loginImg2.webp" class="img-fluid filterlogin m-top">
                                    </div>
                                </div>
                                <div class="col-12 col-md-7">
                                    <!-- <h2 class="regi-acc">{{ $t('login-account','Login Account')}}</h2> -->
                                    <form class="reg-form">
                                        <div class="form-login-tabs">
                                            <nav v-if="$siteSettings?.data?.business_type == 2">
                                                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                                    <button class="nav-link" :class="form.type == 1 ? 'active': ''" id="nav-Phone-tab" 
                                                        data-bs-toggle="tab" data-bs-target="#nav-Phone" type="button" role="tab"
                                                        aria-controls="nav-Phone" aria-selected="true" @click="handleClick(1)">
                                                        {{ $t('phone','Phone')}}
                                                    </button>
                                                    <button class="nav-link" :class="form.type == 2 ? 'active': ''" id="nav-User-tab" 
                                                        data-bs-toggle="tab" data-bs-target="#nav-User" type="button" role="tab" 
                                                        aria-controls="nav-User" aria-selected="false" @click="handleClick(2)">
                                                        {{ $t('user-id','User ID')}}
                                                    </button>
                                                </div>
                                            </nav>
                                            <div class="tab-content" id="nav-tabContent" v-if="$siteSettings?.data?.business_type == 2">
                                                <div class="tab-pane fade" :class="form.type == 1 ? 'show active': ''" id="nav-Phone" role="tabpanel" aria-labelledby="nav-Phone-tab">
                                                    <div class="phonelogin">
                                                        <div class="get-mob">
                                                            <div class="col-auto">
                                                                <select v-model="form.code" class="form-select form-control" id="autoSizingSelect" :class="{'btn-disabled' : isOtpApiCalled && (minutes > 0 || seconds > 0) }">
                                                                    <option :value="allowedCountry.phonecode" v-for="(allowedCountry, countryIndex ) in $siteSettings.data?.country_code_list"
                                                                    :key="countryIndex">+{{ allowedCountry.phonecode }}</option>
                                                                </select>
                                                            </div>
                                                            <div class="inp-img">
                                                                <img  rel="preload"  src="@/assets/images/mob_icon.svg" alt="">
                                                            </div>
                                                            <input v-model="form.mobileNo" type="tel" minlength="10" maxlength="10" class="form-control pl-0" :class="{'btn-disabled' : isOtpApiCalled && (minutes > 0 || seconds > 0) }"
                                                                :placeholder="$t('enter-phone-number', 'Enter Phone Number')" @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999);">
                                                        </div>
                                                        <div>
                                                            <template v-if="init && checkValidation?.mobile?.length > 0" >
                                                                <p v-for="(err, index) in checkValidation?.mobile" :key="index" class="wrong-message mt-1">
                                                                    {{ $t(err.lang, err.error) }}
                                                                </p>
                                                            </template>
                                                        </div>
                                                        <div class="d-flex login-method-section mt-3">
                                                            <div class="label-tabs">
                                                                <input class="form-check-input flexRadioDefault-sec" type="radio" name="login-method" id="login-password" value="password" v-model="loginMethod" @click="form.password =''">
                                                                <label for="login-password">{{$t('password','Password')}}</label>
                                                            </div>
                                                            <div class="label-tabs">
                                                                <input class="form-check-input flexRadioDefault-sec" type="radio" name="login-method" id="login-otp" value="otp" v-model="loginMethod" @click="form.password =''">
                                                                <label for="login-otp">{{$t('otp','OTP')}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tab-pane fade" :class="form.type == 2 ? 'show active': ''" id="nav-User" role="tabpanel" aria-labelledby="nav-User-tab">
                                                    <div class="get-mob">
                                                        <div class="inp-img">
                                                            <img  rel="preload"  src="@/assets/images/user_icon.svg" alt="">
                                                        </div>
                                                        <input type="text" class="form-control add" v-model="form.userId" required="1"
                                                            :placeholder="$t('enter-user-id', 'Enter User ID')" @input="form.userId = $helper.sanitizeDetails('login', form.userId);">
                                                    </div>    
                                                </div>
                                            </div>
                                            <div class="tab-content" id="nav-tabContent" v-else>
                                                <div class="tab-pane fade show active" id="nav-User" role="tabpanel" aria-labelledby="nav-User-tab">
                                                    <div class="get-mob">
                                                        <div class="inp-img">
                                                            <img  rel="preload"  src="@/assets/images/user_icon.svg" alt="">
                                                        </div>
                                                        <input type="text" class="form-control add" v-model="form.userId" 
                                                        :placeholder="$t('enter-user-id', 'Enter User ID')" @input="handleInputUserID($event)">
                                                    </div>    
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <template v-if="init && checkValidation?.userId?.length > 0" >
                                                <p v-for="(err, index) in checkValidation?.userId" :key="index" class="wrong-message mt-1">
                                                    {{ $t(err.lang, err.error) }}
                                                </p>
                                            </template>
                                        </div>
                                        <div class="password-input-box">
                                            <div class="get-mob for eye-pass-visible">
                                                <input :type="passwordFieldType" v-if="loginMethod == 'password'" v-model="form.password" :placeholder="$t('enter-pass', 'Enter Password')"
                                                    class="form-control" @input="form.password = $helper.sanitizeDetails('login', form.password);">
                                                <input v-model="form.password" class="form-control" id="myPassInput" type="text" v-if="loginMethod == 'otp'"
                                                    :placeholder="$t('enter-otp','Enter OTP')" aria-label="password" @input="form.password = $helper.sanitizeNumber(form.password,999999);"
                                                    aria-describedby="addon-wrapping" maxlength="6">
                                                <div class="inp-img">
                                                    <img  rel="preload"  src="@/assets/images/lock_icon.svg" alt="">
                                                </div>
                                                <div class="eye-icn-sec" @click="togglePasswordVisibility()" v-if="loginMethod == 'password'">
                                                    <img  rel="preload"  v-if="passwordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                                    <img  rel="preload"  v-else src="@/assets/images/eye-open.webp">
                                                </div>
                                                <span class="btn btn-primary place-but send-login-otp password-show-hide" :class="{'btn-disabled' : isOtpApiCalled && (minutes > 0 || seconds > 0) }" v-if="loginMethod == 'otp'" @click="sendOtpServiceCall()">
                                                    {{ isOtpApiCalled && (minutes > 0 || seconds > 0) ? formatTime(minutes) + ':' + formatTime(seconds) : (minutes == 0 ? $t('resend-otp','Resend OTP') : $t('send-otp','Send OTP')) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div v-if="showValidationError && form.password == ''">
                                            <p class="wrong-message mt-1">
                                                {{ $t(`please-enter-${loginMethod.toLowerCase()}.`,`Please Enter ${loginMethod}.`)}}
                                            </p>
                                        </div>

                                        <div class="for-pass" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                                            <a data-bs-toggle="modal" href="#staticBackdrop-two" @click="refreshData()">
                                                {{ $t('forgot-password','Forgot Password?')}}
                                            </a>
                                        </div>

                                        <div class="login-btn-wrapper">
                                            <button type="button" @click="signInMethodCall()" class="btn btn-register btn-login-blk loader-btn"
                                                :class="{ 'btn-loading': loading }">
                                                {{ $t('login','Login')}}
                                                <span><b></b><b></b><b></b></span>
                                            </button>
                                            <button type="button" class="btn btn-register btn-login-blk loader-btn"  @click="demoUserLogin()"
                                                :class="{ 'btn-loading': demoLoading }">
                                                {{ $t('demo-login','Log In With Demo ID ')}}
                                                <span><b></b><b></b><b></b></span>
                                            </button>
                                        </div>
                                        
                                        <!-- <template v-if="siteSettings && siteSettings?.business_type == 2">
                                            <h3 class="whats-with">{{ $t('or-login-with','Or Login With')}}</h3>
                                            <ul class="social-icon-wrapper">
                                                <li>
                                                    <a href="Javascript:void(0)">
                                                        <img  rel="preload"  src="@/assets/images/google.png" class="google">
                                                    </a>
                                                </li>
                                            </ul>
                                        </template> -->

                                        <h3 class="whats-with" v-if="$siteSettings?.data?.social_link?.whatsappno1">{{ $t('get-your-ready-made-id-from-whatsapp', 'Get Your Ready-Made ID From WhatsApp') }}</h3>
                                        <div v-if="$siteSettings?.data?.social_link?.whatsappno1" class="button-whatsapp">
                                            <a :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" class="btn-whatsapp" target="_blank">
                                                <img  rel="preload"  src="@/assets/images/whatsapp.webp" alt="">
                                                {{ $t('whatsapp-now','Whatsapp Now ')}}
                                            </a>
                                        </div>
                                        
                                        <div class="login-with-social" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                                            <h3 class="whats-with">{{ $t('or-login-with','Or Login With')}}</h3>
                                            <ul class="social-icon-wrapper" >
                                                <li v-if= "$siteSettings?.data?.social_link?.telegram_link"><a :href="$siteSettings?.data?.social_link?.telegram_link" target="_blank">
                                                    <img src="@/assets/images/telegram-share.svg"></a>
                                                </li>
                                                <li  v-if="$siteSettings?.data?.social_link?.instagram_link"><a :href="$siteSettings?.data?.social_link?.instagram_link" target="_blank"><img src="@/assets/images/instagram-share.svg"></a></li>
                                                <li v-if="$siteSettings?.data?.social_link?.facebook_link"><a :href="$siteSettings?.data?.social_link?.facebook_link" target="_blank"><img src="@/assets/images/facebook-share.svg"></a></li>
                                            </ul>
                                        </div>
                                        
                                        <template v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                                            <p class="whats-with-acc">{{ $t("dont-have-an-account-sign-up","Don’t have an account ?")}} 
                                                <a href="#register-btn" data-bs-toggle="modal"  @click="refreshData()">
                                                    {{ $t('sign-up','Sign UP')}}
                                                </a>
                                            </p>
                                        </template>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AUTH_TOKEN } from "@/shared/constants/cookies-const";
import { setHeaders } from '@/shared/services/headers';
import validate from '../services/authValidation';
import axios from "axios";
export default {
	name: 'Login',
	data() {
    return {
        form: {
            code: "91",
            mobileNo: "",
            userId: "",
            password: "",
            type: this.$siteSettings?.data?.business_type == 2 ? 1 : 2,
            captchaText: "",
        },
        styleObject: {
            display: "none",
        },
        showValidationError: false,
        loading: false,
        demoLoading: false,
        modal: null,
        showDropDown: false,
        passwordFieldType: "password",
        loggedUserCheck: null,
        inputvalue: [
            {
            value: 100,
            },
            {
            value: 500,
            },
            {
            value: 1000,
            },
            {
            value: 2000,
            },
        ],
        init:false,
        phnInit:false,
        loginMethod: 'password',
        isOtpApiCalled: false,
        minutes: 5,
        seconds: 59
    };
  },
  computed: {
    checkValidation() {
        const validationErrors = validate.areFieldsValid(
            'login', 
            this.form.type, 
            this.form.mobileNo, 
            this.form.userId, 
            this.form.password
        );
        if(this.init){
            return validationErrors;
        }
    }
  },
  mounted() {
    this.loggedUserCheck = localStorage.getItem("LoggedUser");
    if(localStorage.getItem('login_type') && this.$siteSettings?.data?.business_type == 2) {
        this.form.type = localStorage.getItem('login_type');		
    };
    if(this.$route.name == 'login' && !this.$auth.status) {
        this.$helper.openModal('#staticBackdrop-one');
    }
    else if(this.$route.name == 'login' && this.$auth.status) {
        this.$router.push('/');
    }
  },
  methods: {
    handleClick(num) {
        this.form.type !== num && this.refreshData();
        this.form.type = num;
    },
    refreshData() {
        this.form = {
            code: "91",
            mobileNo: "",
            userId: "",
            password: "",
            type: 1,
            captchaText: ''
        },
        this.loginMethod = 'password';
        this.isOtpApiCalled = false;
        this.minutes = 5;
        this.seconds = 59;
        this.showValidationError = false;
        this.passwordFieldType = 'password';
        this.init = false
        this.phnInit = false
    },
    demoUserLogin() {
        this.init = false;
        this.form.type = 1;
        this.form.userid = "demouser";
        this.form.password = "demopass";
        this.loginServiceCall('DEMO_LOGIN_API', 'demo')
    },
    signInMethodCall() {
        this.init = true;
        let id = this.getId();
        if (id == "" || this.form.password == "") {
            this.showValidationError = true;
        }
        else {
            this.loginMethod != 'password' ? this.signInwithOtp() : this.loginServiceCall('LOGIN_API', 'nondemo');
        }
    },
    formatTime(value) {
        return value < 10 ? `0${value}` : value;
    },
    setResendTimer() {

        const countdown = () => {
            if (this.minutes === 0 && this.seconds === 0) {
                this.timerRunning = false;
                // Timer has expired, you can perform any action here
            } else {
                if (this.seconds === 0) {
                    this.minutes--;
                    this.seconds = 59;
                } else {
                    this.seconds--;
                }
                setTimeout(countdown, 1000);
            }
        };
        setTimeout(countdown, 1000);
    },
    async sendOtpServiceCall() {
        if(this.form.mobileNo.toString().length != 10) {
            this.$errorToast(this.$t('enter-proper-phn-num','Please enter proper mobile number')) 
            return;
        };
        this.$apiCall('post', 'SEND_OTP', { mobile_number: this.form.mobileNo, cncode: this.form.code }).then(response => {
            this.loadingOtp = false;
            if (response) {
                if (response.status == 200) {
                    this.$successToast(response.data.message);
                    this.isOtpApiCalled = true;
                    this.minutes = 5;
                    this.seconds = 0;
                    this.setResendTimer();
                }
            }
        }).catch(error => {
            if (error)
                this.$errorToast(error[0])
        });
    },
    signInwithOtp() {
        let id = this.getId();
        this.loading = true;
        let data = {
            mobile: id,
            countrycode: this.form.code,
            otp: this.form.password
        };
        this.$store.dispatch('setGlobalLoader', true);
        this.$apiCall('post', 'LOGIN_WITH_OTP', data).then(response => {
            this.$store.dispatch('setGlobalLoader', false);
            this.loading = false;
            if (response) {
                if (response.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response.data.debug[0]);
                    } else {
                    
                        this.$successToast(response.data.message);
                        let userData = response.data.data;
                        if(this.loggedUserCheck!=userData.userid){
                        this.$store.dispatch('setClickBetValue',this.inputvalue);
                        }
                        this.$cookies.set(AUTH_TOKEN, userData.token);
                        this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                        window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                        //for add on all APIs
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                        this.$store.dispatch('setSiteVersion', null);
                        setHeaders();
                        this.setUserDataToStore(userData);
                        localStorage.setItem("LoggedUser",userData.userid)
                        this.refreshData();
                        this.$router.push({name:'Home'});
                        setTimeout(() => {
                            location.reload();
                        }, 100);
                    }
                }
            }
        }).catch(error => {
            this.$store.dispatch('setGlobalLoader', false);

            this.loading = false;
            if (error) {
                this.$errorToast(error[0]);
            }
        });
    },  
    async loginServiceCall(url, type) {
        let id = this.getId();
        if (type == 'demo') {
            this.demoLoading = true;
        } else {
            this.loading = true;
        }
        let data = {
            "userid": id.toString(),
            "type": this.$siteSettings.data.business_type == 1 ? 2 : this.form.type,
            "password": this.form.password,
            "cncode": this.form.code,
        };
        this.$store.dispatch('setGlobalLoader', true);
        this.$apiCall('post', url, data).then(response => {
            this.demoLoading = false;
            this.loading = false;
            this.$store.dispatch('setGlobalLoader', false);
            if (response) {
                if (response.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response.data.debug[0]);
                    } else {
                        this.$successToast(response.data.message);
                        let userData = response.data.data;
                        if(this.loggedUserCheck!=userData.userid){
                            this.$store.dispatch('setClickBetValue',this.inputvalue);
                            this.$store.dispatch('setIsClickBetOn',false);
                        }
                        this.$cookies.set(AUTH_TOKEN, userData.token);
                        this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                        window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                        localStorage.setItem('login_type', data.type)
                        //for add on all APIs
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                        localStorage.setItem("LoggedUser",userData.userid)
                        setHeaders();
                        this.setUserDataToStore(userData);
                        this.refreshData();
                        setTimeout(() => {
                            location.reload();
                        }, 100);
                    }
                }
            }
        }).catch(error => {
            this.$store.dispatch('setGlobalLoader', false);
            if (type == 'demo') {
                this.demoLoading = false;
            } else {
                this.loading = false;
            }
            if (error) {
                this.$errorToast(error[0]);
            }
        });
    },
    getId() {
        if (this.$siteSettings.data.business_type == 2) {
            return this.form.type == 1 ? this.form.mobileNo : this.form.userId;
        } else {
            return this.form.userId;
        }
    },
    setUserDataToStore(userData) {
        let asciiCodes = null;
        for (let i = 0; i < userData.userid.length; i++) {
            asciiCodes += userData.userid.charCodeAt(i)
        }
        let user = {
            balance: userData.balance,
            currency: userData.currency,
            currency_slug: userData.currency_slug,
            last_login_at: userData.last_login_at,
            name: userData.name,
            rid: userData.rid,
            userid: userData.userid,
            exposure: userData.expl,
            available_credits: userData.available_credits,
            id: userData.id,
            exp: userData.exp,
            notificationSubscribed: null,
            notificationUnsubscribed: null,
            activeWallet: userData.actw,
            asciiCodes: asciiCodes,
            cpi: userData.cpi,
        }
        this.$store.dispatch('setUser', user);
        this.$store.dispatch('setChips', userData.chips);
        this.$store.dispatch('setEventManage', userData.lock_settings);
    },
    togglePasswordVisibility(fieldName) {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    }
  },

}
</script>

<style scoped>
div.mm-dropdown ul li {
    display: flex !important;
    padding-left: 25px;
}
select#autoSizingSelect {
    font-size: 14px;
}
.pl-0 {
    padding-left: 0px !important;
}
</style>